<app-alert-box-component 
  (OnButtonClick)="onAlertButtonClick($event)"
  (OnAlertClose)="closeAlert($event)" 
  (OnAlertVisibility)="alertVisibility($event)"
  [bShowSecondButton]="bShowSecondAlertButton"
  [alertHeaderText]="alertHeaderText" 
  [alertBodyText]="alertBodyText" 
  [closeButtonText]="alertCloseButtonText"
  [secondButtonText]="alertSecondButtonText"
  [data]="alertBoxData"
  [bAlert]="bAlert"></app-alert-box-component>
  
<c-navbar expand="lg" class="border-bottom border-bottom-3 border-bottom-primary">
    <c-container fluid>
    <form cForm class="row" [formGroup]="cifSearchForm" (ngSubmit)="generateReport()">
        <c-row [gutter]="{gy: 1}">
            <c-col md="auto">
                <c-input-group class="has-validation" >
                    <span cInputGroupText>
                        Report Type
                    </span>
                    <select cSelect id="reportType" name="reportType" formControlName="searchReportTypeControl" (change)="onSelectChange()">
                        <option *ngFor="let makerCheckerFunctions of reportTypes" [value]="makerCheckerFunctions.functionKey">
                            {{makerCheckerFunctions.functionValue}}
                        </option>
                    </select>
                </c-input-group>
            </c-col>
        </c-row>
        <c-row [gutter]="{gy: 1}">
            <c-col lg="5">
                <c-date-range-picker [startDate]="startDate" [endDate]="endDate" (startDateChange)="onStartDateChane($event)" (endDateChange)="onEndDateChane($event)"></c-date-range-picker>
            </c-col>
            <c-col md="auto">
                <button cButton type="submit">
                    Generate Report
                </button>
            </c-col>
            <c-col *ngIf="bShowDownloadButton" md="auto">
                <button cButton (click)="downloadReport()">
                    Download Report
                </button>
            </c-col>
        </c-row>
    </form>
</c-container>
</c-navbar>

<c-smart-table id="auditReportTable"
[columnSorter]="true"
[columns]="columns"
[columnFilter]="true"
[itemsPerPageSelect]="true"
[pagination]="false"
[itemsPerPage]="nItems"
[items]="reportData"
[tableBodyProps]="{ align: 'middle' }"
[tableProps]="{ hover: true, striped: true, responsive: true }"
clickableRows
header>
<ng-template cTemplateId="tableData" let-columnName="columnName" let-item="item" let-tdContent="tdContent">
    <td>
    <ng-container [ngSwitch]="columnName">
        <ng-container *ngSwitchCase="'createdOn'">
            {{(getCreatedOnDisplayDate(item.createdOn))}}
        </ng-container>
        <ng-container *ngSwitchCase="'decisionOn'">
            {{(getDecisionOnDisplayDate(item))}}
        </ng-container>
        <ng-container *ngSwitchCase="'isApproved'">
            {{(getApprovalText(item))}}
        </ng-container>
        <ng-container *ngSwitchCase="'isMiddlewareSuccess'">
            {{(getMiddlewareText(item))}}
        </ng-container>
        <ng-container *ngSwitchDefault>
            {{tdContent}}
        </ng-container>
    </ng-container>
    </td>
</ng-template>
</c-smart-table>